import { render, staticRenderFns } from "./-checkout.vue?vue&type=template&id=e2df535a&scoped=true"
import script from "./-checkout.vue?vue&type=script&lang=js"
export * from "./-checkout.vue?vue&type=script&lang=js"
import style0 from "./-checkout.vue?vue&type=style&index=0&id=e2df535a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2df535a",
  null
  
)

export default component.exports